import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
const AddUsers = () => {

    let navigate=useNavigate()

    const [user,setUser]=useState({
        name:"",
        username:"",
        email:""
    })

    const {name,username,email} = user;

    const onInputChange=(e)=>{

        setUser({...user,[e.target.name]:e.target.value})
    }


    const onSubmit=async(e)=>{
        e.preventDefault()

        await axios.post("https://crud-application-backend-otm5.onrender.com/user",user);
        navigate("/")
    }

  return (
    <div className='container'> 

    <div className='row'>
        <div className='col-md-6 offset-md-3 border rounded p-4 mt shadow'>
            <form onSubmit={(e)=>onSubmit(e)}>
            <h2 className='text-center m-4'> Register User</h2>
            <div className='mb-3'>
                
                <label htmlFor='name' className='form-label'>
                 Name
                </label>
                <input type={'text'} className='form-control' placeholder='Enter Your Name' name='name' value={name} onChange={(e)=>onInputChange(e)}></input>
            </div>
             <div className='mb-3'>
                <label htmlFor='username' className='form-label'>
                 UserName
                </label>
                <input type={'text'} className='form-control' placeholder='Enter Your UserName' name='username' value={username} onChange={(e)=>onInputChange(e)}></input>
            </div>
             <div className='mb-3'>
                <label htmlFor='email' className='form-label'>
                 Email
                </label>
                <input type={'text'} className='form-control' placeholder='Enter Your Email' name='email' value={email} onChange={(e)=>onInputChange(e)}></input>
            </div>
            <button type={"submit"} className='btn btn-outline-primary'>Submit</button>
                        <Link className="btn btn-outline-danger mx-2" to="/">Cancel</Link>
                         </form>
          
        </div>
    </div>
    </div>

  )
}

export default AddUsers